import { createRouter,createWebHashHistory,createWebHistory } from 'vue-router'
import LayoutDefault from "../layout/index.vue";

const routes = [
  {
    path:'/',
    name:'Home',
    component:LayoutDefault,
	redirect: "/Home",
    meta:{
      iconClass: "iconfont icon-home",
      title: "首页",
    },
	children: [
	  {
	    path: "/Home",
	    component: () => import("../views/Home/index.vue"),
	    name: "Home",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "首页",
	    },
	  },
    {
	    path: "/MenuManagement",
	    component: () => import("../views/MenuManagement/index.vue"),
	    name: "MenuManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "菜单管理",
	    },
	},
    {
	    path: "/RoleManagement",
	    component: () => import("../views/RoleManagement/index.vue"),
	    name: "RoleManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "角色权限管理",
	    },
	},
    {
	    path: "/AdminManagement",
	    component: () => import("../views/AdminManagement/index.vue"),
	    name: "AdminManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "管理员列表",
	    },
	},
    {
	    path: "/IpBlackManagement",
	    component: () => import("../views/IpBlackManagement/index.vue"),
	    name: "IpBlackManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "IP黑名单",
	    },
	},
    {
	    path: "/LogManagement",
	    component: () => import("../views/LogManagement/index.vue"),
	    name: "LogManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "日志管理",
	    },
	},
    {
	    path: "/ArticleSourceManagement",
	    component: () => import("../views/ArticleSourceManagement/index.vue"),
	    name: "ArticleSourceManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "图文来源管理",
	    },
	},
    {
	    path: "/MajorEventsManagement",
	    component: () => import("../views/MajorEventsManagement/index.vue"),
	    name: "MajorEventsManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "重大活动",
	    },
	},
    {
	    path: "/FanClubActivitiesManagement",
	    component: () => import("../views/FanClubActivitiesManagement/index.vue"),
	    name: "FanClubActivitiesManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "会员活动",
	    },
	},
    {
	    path: "/OrganizationalStructureManagement",
	    component: () => import("../views/OrganizationalStructureManagement/index.vue"),
	    name: "OrganizationalStructureManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "组织架构管理",
	    },
	},
    {
	    path: "/ImageManagement",
	    component: () => import("../views/ImageManagement/index.vue"),
	    name: "ImageManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "图片及位置管理",
	    },
	},
    {
	    path: "/FriendshipLinkManagement",
	    component: () => import("../views/FriendshipLinkManagement/index.vue"),
	    name: "FriendshipLinkManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "友情链接管理",
	    },
	},
    {
	    path: "/DictionaryManagement",
	    component: () => import("../views/DictionaryManagement/index.vue"),
	    name: "DictionaryManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "字典管理",
	    },
	},
	{
	    path: "/MemberManagement",
	    component: () => import("../views/MemberManagement/index.vue"),
	    name: "MemberManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "会员列表",
	    },
	},
	{
	    path: "/MediaCoverageManagement",
	    component: () => import("../views/MediaCoverageManagement/index.vue"),
	    name: "MediaCoverageManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "媒体报道",
	    },
	},
	{
	    path: "/DramaManagement",
	    component: () => import("../views/DramaManagement/index.vue"),
	    name: "DramaManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "剧目管理",
	    },
	},
	{
	    path: "/DramaActorTitleManagement",
	    component: () => import("../views/DramaActorTitleManagement/index.vue"),
	    name: "DramaActorTitleManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "职称管理",
	    },
	},

	

	








	]
  },
  {
    path: "/Login",
    component: () => import("@/views/Login/index.vue"),
    name: "Login",
    hidden: true,
    meta: {
      title: "登录",
    },
  },
]

const router = createRouter({
	//createWebHistory = 没有#号
	//createWebHashHistory = 有#号
	history: createWebHistory(),
	routes
})

export default router
